import { Button, Card, Flex, Heading, Text } from "@radix-ui/themes";
import { supabase } from "../lib/supabase";
import { redirectToFlow360Login } from "../flow360/api";

export default function SignIn() {
  // Include the base path (e.g. "/thread") for subpath deployments.
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");
  const callbackUrl = `${window.location.origin}${base}/auth/callback`;

  const handleGoogle = async () => {
    await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo: callbackUrl },
    });
  };

  const handleGitHub = async () => {
    await supabase.auth.signInWithOAuth({
      provider: "github",
      options: { redirectTo: callbackUrl },
    });
  };

  const handleFlow360 = () => {
    redirectToFlow360Login();
  };

  return (
    <Flex
      justify="center"
      align="center"
      style={{ minHeight: "100vh", background: "var(--color-background)" }}
    >
      <Card size="4" style={{ width: 380, padding: 32 }}>
        <Flex direction="column" gap="4" align="center">
          <Heading size="6">Sign in to Thread</Heading>
          <Text size="2" color="gray" align="center">
            Provenance tracking for computational workflows
          </Text>

          <Flex direction="column" gap="3" style={{ width: "100%" }}>
            <Button
              size="3"
              variant="surface"
              onClick={handleGoogle}
              style={{ width: "100%", cursor: "pointer" }}
            >
              Continue with Google
            </Button>
            <Button
              size="3"
              variant="surface"
              onClick={handleGitHub}
              style={{ width: "100%", cursor: "pointer" }}
            >
              Continue with GitHub
            </Button>
            <Button
              size="3"
              variant="surface"
              color="orange"
              onClick={handleFlow360}
              style={{ width: "100%", cursor: "pointer" }}
            >
              Continue with Flow360
            </Button>
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
}
